import {priority} from '@priority-software/priority-proto-api/lib';
import {Scrollbar, TreeNodeProps} from '@priority-software/priority-style-react';
import React, {memo, useRef} from 'react';
import FieldItem from './FieldItem';
import styles from './styles.module.scss';
import {isRTL} from '../../../../Localization';
import {updateOuterJoinMap} from '../../actions';
import {BasicFormData} from '../../types';
import {reportGeneratorsStore} from '../../stores/ReportGeneratorsStore';

interface Props {
    fields: priority.netitems.nrest.ITreeNode[];
    searchQuery: string;
    isSelected: (id: string) => boolean;
    onSelect: (field: priority.netitems.nrest.ITreeNode, currentForm: BasicFormData) => void;
    onZoom: (nodeId: string, title: string) => void;
    currentForm: BasicFormData;
    scrollbarRef?: React.RefObject<any>; // Reference to the scrollbar component
}
const FieldSelectList = memo(
    ({fields, searchQuery, isSelected, onSelect, onZoom, currentForm, scrollbarRef}: Props) => {
        // Use provided scrollbarRef or create a local one if not provided
        const localScrollbarRef = useRef(null);
        const effectiveScrollbarRef = scrollbarRef || localScrollbarRef;

        const handleZoom = (nodeId: string, title: string, currentForm: BasicFormData = null) => {
            onZoom(nodeId, title);
            const {currentScreen} = reportGeneratorsStore;
            const {currentReport} = currentScreen;
            const isParallelToBaseForm = currentReport.nodeId === currentForm?.id;
            const node: TreeNodeProps = {
                title,
                id: nodeId,
                nodes: []
            };
            if (isParallelToBaseForm) {
                node.isMain = true;
                updateOuterJoinMap(node);
            } else {
                node.extraData = {isZoomed: true};
                updateOuterJoinMap(node, currentForm);
            }
            effectiveScrollbarRef?.current?.scrollToTop();
        };

        return (
            <Scrollbar
                scrollbarRef={effectiveScrollbarRef}
                autoHide
                style={{width: '100%'}}
                autoHeight
                autoHeightMax={257}
                rtl={isRTL()}
            >
                <div className={styles.listContainer}>
                    {fields?.map(field => (
                        <FieldItem
                            field={field}
                            key={`${field.NodeId}_${field.Title}_${currentForm.title}`}
                            currentForm={currentForm}
                            onSelect={onSelect}
                            isSelected={isSelected}
                            onZoom={handleZoom}
                            searchQuery={searchQuery}
                        />
                    ))}
                </div>
            </Scrollbar>
        );
    }
);

export default FieldSelectList;
